import { render, staticRenderFns } from "./SendArea.vue?vue&type=template&id=188c0812&"
import script from "./SendArea.vue?vue&type=script&lang=js&"
export * from "./SendArea.vue?vue&type=script&lang=js&"
import style0 from "./SendArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports